export default "__VITE_ASSET__Cz5z27U2__"